// This file will be deleted once all the calculators are configBuilder free
// to be deleted

import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { ApplyNowLink } from '@nerdwallet/react-apply-now';

import {
  getCityLifeFreeCreditScore,
  HOME_LIGHT_IMPRESSION,
} from '../../lib/analytics-constants';
import registerLink from '../../lib/register-link';

const config = {
  header: 'Other NerdWallet resources',
  iconUrl: iconUri('Money_hack'),
  impressionTrackingName: 'col-tool-card',
  cards: [
    {
      header: 'Rates',
      text: 'A low rate can save you hundreds each year.',
      img: iconUri('House_pricetag'),
      link: {
        url: '/mortgages/mortgage-rates?trk_source=mortgages_col_toolcard&trk_content=rates_toolcard_card+pos1&trk_destination=mortgage-rates&trk_origin=calculate-mortgage-payment&trk_app=tool&bypass=true',
        text: 'Compare mortgage rates',
      },
      keys: [
        {
          key: 'inputs.homePrice',
        },
        {
          key: 'inputs.downpayment',
        },
        {
          key: 'outputs.zip',
        },
      ],
    },
    {
      header: 'Credit',
      text: 'See how a mortgage impacts your score.',
      img: iconUri('Credit_score'),
      link: registerLink(
        'col',
        {
          element: 'ad_unit',
          location: 'toolcard_card+pos2',
        },
        'Get your free credit score'
      ),
      impressionEventPayload: getCityLifeFreeCreditScore(),
    },
    {
      header: 'Lenders',
      text: 'Get your true budget and find a home with ease.',
      img: iconUri('Approval'),
      link: {
        url: '/mortgages/mortgage-pre-approval?trk_source=mortgages_col_toolcard&trk_content=preapproval_toolcard_card+pos3&trk_destination=mortgage-pre-approval&trk_origin=calculate-mortgage-payment&trk_app=tool',
        text: 'Get preapproved',
      },
    },
    {
      header: 'Agents',
      text: 'Get matched with a top agent in your area.',
      img: iconUri('Real_estate_1'),
      link: {
        linkComponent: ApplyNowLink,
        text: 'Find a real estate agent',
        props: {
          linkType: 'apply_now_button',
          logImpression: false,
          link: '/redirect/eeadcaf6-38db-11eb-a727-ef6ff84e35fe',
        },
        getAdditionalProps: (impressionData) => ({
          impressionId: impressionData?.impressionId,
        }),
      },
      impressionEventPayload: {
        ...HOME_LIGHT_IMPRESSION,
        payload: {
          ...HOME_LIGHT_IMPRESSION.payload,
          section_name: 'city_life_tool_card',
          section_position: 10,
        },
      },
    },
    {
      header: 'Tools',
      text: "Compare some of America's most popular cities.",
      img: iconUri('Lightbulb'),
      link: {
        url: '/cost-of-living-calculator',
        text: 'Cost of living calculator',
      },
    },
  ],
};
export default config;
